<script setup>
import { ref, defineAsyncComponent } from 'vue'
import { event, fetchEventFromWordpress } from "@/Mixins/FetchesEventsFromWordpress"
import { useForm } from '@inertiajs/inertia-vue3';

import BlockLoader from "@/Shared/VisualComponents/BlockLoader"

// we wrap eventData in an inertia form so we can edit it
const form = useForm(props.eventData);

/**
 * We're handling the events half in and half out of wordpress - every page load, we'll fetch data directly 
 * from wordpress, but we have some extra data we need to store against the event, so we also have our own
 * Event model in the database. In the UI we refer to the wordpress event as "event" and to the extra data
 * that we are storing on our server as "eventData".
 * 
 * Our eventData has a remote_id field that is the same as the wordpress event id.
 */
const props = defineProps({
	eventData: {
		type: Object,
		required: true,
	},
	organisations: {
		type: Array,
		required: true,
	},
})

// we'll load events from the WP api before showing this page so lets use an asyncCompnent
const AsyncComp = defineAsyncComponent({
	loader: () => {
		return new Promise((resolve) => {
			// fetchEventFromWordpress is provided by our mixin
			fetchEventFromWordpress(props.eventData.remote_id).then(() => {
				resolve(import('@/Pages/Events/Edit.vue'))
			})
		})
	},
	loadingComponent: BlockLoader,
	timeout: 5000,
})

</script>

<template>
	<AsyncComp 
		:event="event"
		:event-data="form"
		:organisations="organisations"
		@update:eventdata="updateEventData" 
	/>
</template>